require('./errorList.less');
import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');

export const statuses = [
    {output: "Alle", input: undefined},
    {output: "Ubehandlet", input: "UNHANDLED"},
    {output: "Oppdatert", input: "UPDATED"},
    {output: "Feilet", input: "FAILED"},
    {output: "Ignorert", input: "IGNORED"}
];

class ErrorListController {
    erpSessions;
    selected;
    promise;
    query ={
        limit: 100,
        limitOptions: [20, 50, 100, 200],
        page: 1,
        order: ''
    };
    urlListener;
    queryListener;
    types = ["RECEIVE", "PICK", "MOVE", "COUNT", "CORRECTION"];
    statuses = statuses;
    activeState;
    selectedType;
    selectedStatus;


    constructor(private toastService, private Erp, private $location, private $state, private $scope){
        $scope.query = this.query;
        this.urlListener = $scope.$on('$locationChangeSuccess', ()=>{
            if(this.activeState === this.$state.current.name) {
                this.getTransactions();
            }
        });
    }


    $onInit() {
        this.activeState = angular.copy(this.$state.current.name);
        this.initiateStatuses();
        this.setUrl(true);
        this.queryListener = this.$scope.$watchCollection('query' , ()=>{
            this.setUrl(false);
        });
    }

    $onDestroy(){
        this.urlListener();
        this.queryListener();
    }

    getTransactions() {
        this.promise = this.Erp.getSessions({
            pageNo: this.query.page - 1,
            pageSize: this.query.limit,
            status: this.selectedStatus === 'ALL' ? undefined : this.selectedStatus,
            type: this.selectedType})
        .$promise.then((result)=> {
            this.erpSessions = result;
            this.erpSessions.content = this.erpSessions.content.map(erpSession => {
                const status =  _.find(this.statuses, {input:erpSession.status});
                erpSession.displayStatusName =  status.output;
                return erpSession;
            });
        }, (error) => {
            this.toastService.parseError(error);
        })
    }

    setUrl(fromInit){
        this.$location.search({type: this.selectedType, status: this.selectedStatus, pageNo: this.query.page, pageSize: this.query.limit});
        if(fromInit){
            this.getTransactions();
        }
    }

    initiateStatuses(){
        const params = this.$location.$$search;
        this.selectedType = params.type;
        this.selectedStatus = params.status ? params.status : "FAILED";
        this.query.page = params.pageNo ? params.pageNo : 1;
        this.query.limit = params.pageSize ? params.pageSize : 100;
    }

    rowSelected(item){
        this.$state.go('loggedin.error_list_detailed', {id: item.id});
    }

    manuallyTreated(ev, item){
        ev.stopPropagation();
        this.updateTransaction("Ignore", item.id);
    }

    redo(ev, item){
        ev.stopPropagation();
        this.updateTransaction("Resend", item.id);
    }

    updateTransaction(type, id){
        this.Erp.updateTransaction({id:id, action:type}, {}).$promise.then(() => {
            this.getTransactions();
            this.toastService.showSimpleToast(type === 'Ignore' ? "Manuelt behandlet" : "Sendt på nytt", 3000);
        }, (error) => {
            this.toastService.parseError(error);
        });
    }

}

class ErrorListOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcErrorListController";
    public template: any = require('./errorList.html');
}

rkcApp.controller("rkcErrorListController", ['toastService', 'Erp', '$location', '$state', '$scope', function(toastService, Erp, $location, $state, $scope){
    return new ErrorListController(toastService, Erp, $location,$state, $scope);
}])
    .component("rkcErrorList", new ErrorListOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/errorList/errorList.ts
 **/